import { useMatomo } from '@datapunt/matomo-tracker-react';
import _get from 'lodash/get';
import _omitBy from 'lodash/omitBy';
import _isUndefined from 'lodash/isUndefined';
import isNull from 'lodash/isNull';

import ubt from 'configs/ubt';
import { useEffect } from 'react';

const omitUndefinedAndNull = (obj) => _omitBy(_omitBy(obj, _isUndefined), isNull);

const useUBTTracker = (options) => {
    const { trackPageView, trackEvent } = useMatomo();
    const { defaultCategory } = options;

    useEffect(() => {
        trackPageView();
    }, []);

    return {
        trackPageView,
        trackEvent: (...args) => {
            let category = defaultCategory, action, name, value;

            if (category !== undefined && category !== null) {
                [action, name, value] = args;
            } else {
                [category, action, name, value] = args;
            }

            action = (ubt[category] && ubt[category][action]) || _get(ubt[category], action);
            const params = omitUndefinedAndNull({ category, action, name, value });
            console.group('Matomo');
            console.log(params);
            console.groupEnd();
            if (action !== undefined) {
                trackEvent(params);
            }
        }
    };
};

export default useUBTTracker;
